import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/layout/layout'
import { Seo } from '../components/seo-copy'
import Title from '../components/title'
import BodyText from '../components/body-text'
import Text from '../components/text'
import Hero from '../components/hero-detail'
import {
  filterArrayByType,
  renderAsHtml,
  renderAsText,
  renderImageUrl,
  hasSlice,
} from '../utility'
import PricingCallout from '../components/pricing-callout'
import RelatedLinks from '../components/related-links/index.js'
import ListColumns from '../components/list-columns/index.js'
import TableDateRange from '../components/table-date-range'
import TableOvernights from '../components/table-overnights'
import AddOnSection from '../components/add-on/add-on-section.js'
import TextBlocks from '../components/text-blocks'
import CallOutBlock from '../components/call-out/call-out-block'
import Button from '../components/button/button-link.js'
import MediaBlock from '../components/media-block'
import CognitoForm from '../components/cognito-form'
import { getItems } from '../galaxy'
import WishListCard from '../components/wish-list-card/wish-list-card'
import ImageModal from '../components/image-modal'
import * as styles from './detail.module.css'

class detail extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      items: [],
    }
  }

  componentDidMount() {
    getItems((res) => {
      this.setState({ items: res })
    })
  }

  render() {
    let { items } = this.state
    const doc = this.props.data?.allPrismicDetail?.nodes[0]?.data
    const meta = this.props.data?.allPrismicDetail?.nodes[0]

    // console.log('DETAIL doc -->', doc)
    if (!doc) return null

    const {
      meta_title,
      meta_description,
      wide_image,
      tall_image,
      title,
      body_text,
      optional_image,
      body,
    } = doc

    let headerCallout = null
    if (body) {
      headerCallout = filterArrayByType(body, 'header_callout')
      headerCallout = headerCallout.length > 0 ? headerCallout[0].primary : null
    }

    let imageModal = null;
    if (body) {
      imageModal = filterArrayByType(doc.body, 'image_modal');
      imageModal = imageModal.length > 0 ? imageModal[0].primary : null
    }

    const hasRelatedLinks = hasSlice(body, 'related_links')
    const hasBannerCallout = hasSlice(body, 'banner_callout')
    const hasWishlistCards = hasSlice(body, 'wish_list_cards')
    const hasListColumns = hasSlice(body, 'list_columns')
    const listColData = filterArrayByType(body, 'list_columns');
    const hasSidebar = hasRelatedLinks || headerCallout || optional_image?.url || imageModal


    const ctaButton = filterArrayByType(body, 'cta_button')
    /* console.log('ctaButton', ctaButton) */
    const hasCtaButton = ctaButton.length > 0

    let section
    if (meta.tags.includes('Animal Encounters')) {
      section = 'animals'
    } else if (meta.tags.includes('Homeschool')) {
      section = 'education'
    } else if (meta.tags.includes('Overnights')) {
      section = 'camps'
    } else if (meta.tags.includes('Volunteer')) {
      section = 'support-us'
    } else if (meta.tags.includes('Zoomobile')) {
      section = 'education'
    } else if (meta.tags.includes('Preschool')) {
      section = 'education'
    } else if (meta.tags.includes('Visit')) {
      section = 'visit'
    } else if (meta.tags.includes('Get Involved')) {
      section = 'support-us'
    }

    let parentPage = null
    if (meta.tags.includes('Animal Encounters')) {
      parentPage = {
        title: 'Animal Encounters',
        url: '/animal-encounters',
      }
    } else if (meta.tags.includes('Homeschool')) {
      parentPage = {
        title: 'Homeschool',
        url: '/homeschool',
      }
    } else if (meta.tags.includes('Overnights')) {
      parentPage = {
        title: 'Overnights',
        url: '/overnights',
      }
    } else if (meta.tags.includes('Volunteer')) {
      parentPage = {
        title: 'Volunteers',
        url: '/volunteers',
      }
    } else if (meta.tags.includes('Zoomobile')) {
      parentPage = {
        title: 'Zoomobile',
        url: '/zoomobile',
      }
    } else if (meta.tags.includes('Preschool')) {
      parentPage = {
        title: 'Preschool',
        url: '/preschool',
      }
    } else if (meta.tags.includes('Donations')) {
      parentPage = {
        title: 'Donations',
        url: '/donate',
      }
    } else if (meta.tags.includes('Daily Schedule')) {
      parentPage = {
        title: 'Daily Schedule',
        url: '/daily-schedule',
      }
    } else if (meta.tags.includes('Preschool')) {
      parentPage = {
        title: 'Preschool',
        url: '/preschool',
      }
    } else if (meta.tags.includes('Animal Care Academy')) {
      parentPage = {
        title: 'Animal Care Academy',
        url: '/animal-care-academy',
      }
    } else if (meta.tags.includes('Aquarium')) {
      parentPage = {
        title: 'Aquarium',
        url: '/aquarium',
      }
    }

    return (
      <Layout
        title={title.text}
        section={section}
        parent={parentPage}
        {...this.props}
      >
        <Hero
          image={wide_image.url}
          tallImage={tall_image.url}
          pageId={meta.id}
        />
        <BodyText>
          <div className="container">
            <div className="row">
              {' '}
              {!hasWishlistCards && (
                <div className="offset-md-1 col-md-10">
                  <Title className={styles.title}>{title.text}</Title>
                </div>
              )}
            </div>
            {!hasSidebar && (
              <div className="row">
                <div className="offset-md-1 col-md-10">
                  {body_text && renderAsText(body_text.text).length > 0 && (
                    <Text>{body_text.richText}</Text>
                  )}
                  <TextBlocks body={body} />
                </div>
              </div>
            )}
            {!hasWishlistCards && hasSidebar && (
              <div className="row">
                <div className="offset-md-1 col-md-7">
                  {body_text && renderAsText(body_text.text).length > 0 && (
                    <Text>{body_text.richText}</Text>
                  )}
                  <TextBlocks body={body} />
                </div>
                <div className="col-md-3">
                  {headerCallout && (
                    <div className={`${styles.callOut}`}>
                      <div className={styles.callOutInner}>
                        {headerCallout.header_callout_title && (
                          <p className={styles.calloutTitle}>
                            {renderAsText(
                              headerCallout.header_callout_title.richText
                            )}
                          </p>
                        )}
                        {renderAsHtml(
                          headerCallout.header_callout_text.richText
                        )}
                        {headerCallout.header_callout_button_link && (
                          <div className={styles.callOutButton}>
                            <Button
                              text={headerCallout.header_callout_button_label}
                              link={
                                headerCallout.header_callout_button_link?.url
                              }
                              color="Zoo Green"
                              size="smallLongText"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {optional_image?.url && (
                    <figure className={styles.activityFigure}>
                      <img
                        src={optional_image?.url}
                        className={`${styles.activityImage} img-fluid`}
                        alt={optional_image?.alt}
                      />
                    </figure>
                  )}

                  {imageModal?.url && (
                    <ImageModal
                      image={imageModal?.primary?.image}
                      alt={imageModal?.primary?.image}
                      id={imageModal?.primary?.image_modal_id}
                    />
                  )}

                  <RelatedLinks body={body} />
                </div>
              </div>
            )}
            {hasSidebar && hasWishlistCards && (
              <>
                <div className="offset-lg-1 col-lg-10">
                  <div className={styles.wishlistHeaderWrapper}>
                    <Title className={styles.wishlistTitle}>{title}</Title>
                    <span className={styles.wishlistSubhead}>
                      Choose items from our Wish List and help provide animal enrichment for nearly 10,000 animals that call the Kansas City Zoo & Aquarium home.
                    </span>
                  </div>
                </div>
                <div className="row">
                  <div className="offset-lg-1 col-lg-7">
                    {body_text && renderAsText(body_text.text).length > 0 && (
                      <Text>{body_text.richText}</Text>
                    )}
                    <TextBlocks body={body} />
                  </div>
                  <div className="col-lg-3">
                    {headerCallout && (
                      <>
                        {headerCallout.header_callout_title && (
                          <div className={styles.sidebarTitle}>
                            <span className={styles.calloutTitle}>
                              {renderAsText(
                                headerCallout.header_callout_title.text
                              )}
                            </span>
                          </div>
                        )}{' '}
                        <div className={styles.wishlistSidebar}>
                          {headerCallout.header_callout_button_link && (
                            <div className={styles.callOutButton}>
                              <Button
                                text={headerCallout.header_callout_button_label}
                                link={
                                  headerCallout.header_callout_button_link?.url
                                }
                                color="Zoo Green"
                                size="small"
                              />
                            </div>
                          )}
                          {renderAsHtml(
                            headerCallout.header_callout_text.richText
                          )}
                          <div className={`${styles.address} mt-2`}>
                            <span>
                              <strong>Kansas City Zoo & Aquarium</strong>
                            </span>
                            <span>6800 Zoo Drive</span>
                            <span>Kansas City, MO 64132</span>
                          </div>
                          <div className="mt-3">
                            <span className={styles.sidebarFooter}>
                              Thank you for supporting KCZoo!
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </>
            )}

            {hasListColumns && (
              <div className="row">
                <div className="offset-md-1 col-md-10">
                  <ListColumns body={body} />
                </div>
              </div>
            )}

            {hasBannerCallout && (
              <div className="row">
                <div className="offset-md-1 col-md-10">
                  {body && <PricingCallout body={body} items={items} />}
                </div>
              </div>
            )}
          </div>
          {hasCtaButton && (
            <div className="container mt-5">
              <div className="row">
                <div class="offset-md-1 col-md-10">
                  <Button
                    text={ctaButton[0].primary.label}
                    link={ctaButton[0].primary.link}
                    color={ctaButton[0].primary.color}
                    size="large"
                  />
                </div>
              </div>
            </div>
          )}
        </BodyText>
        <TableDateRange body={body} />
        <TableOvernights body={body} />
        <AddOnSection body={body} />
        <CallOutBlock body={body} />
        <MediaBlock body={body} />
        {hasWishlistCards && (
          <div className={styles.wishlistSection}>
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2 className={styles.wishlistSectionTitle}>
                    Select a team to see how you can give!
                  </h2>
                  <div className={`${styles.cardContainer} d-flex`}>
                    <WishListCard
                      cards={
                        filterArrayByType(body, 'wish_list_cards')[0].items
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {hasSlice(body, 'cognito_form') &&
          filterArrayByType(body, 'cognito_form')[0].primary.form_id_number && (
            <CognitoForm
              id={
                filterArrayByType(body, 'cognito_form')[0].primary
                  .form_id_number
              }
            />
          )}
      </Layout>
    )
  }
}

export default detail

export const Head = ({ data, location }) => (
  <Seo
    title={data?.allPrismicDetail?.nodes[0]?.data?.meta_title}
    description={data?.allPrismicDetail?.nodes[0]?.data?.meta_description
    }
    pathname={location.pathname}
  />
)

export const query = graphql`
  query DetailQuery($uid: String) {
    allPrismicDetail(filter: { uid: { eq: $uid } }) {
      nodes {
        _previewable
        data {
          meta_title
          meta_description
          wide_image {
            alt
            url
          }
          tall_image {
            alt
            url
          }
          title {
            richText
            text
          }
          body_text {
            richText
            text
          }
          optional_image {
            alt
            url
          }
          body {
            ... on PrismicDetailDataBodyImageModal {
              id
              primary {
                image {
                  alt
                  url
                }
                image_modal_id
              }
              slice_type
              slice_label
            }
            ... on PrismicDetailDataBodyListColumns {
              id
              items {
                list_column_item {
                  text
                }
              }
              primary {
                list_column_header {
                  text
                }
              }
              slice_label
              slice_type
            }
            ... on PrismicDetailDataBodyCtaButton {
              id
              slice_label
              slice_type
              primary {
                color
                label
                link {
                  link_type
                  url
                  type
                  tags
                  uid
                }
              }
            }
            ... on PrismicDetailDataBodyBodyTextParagraphs {
              id
              slice_label
              slice_type
              items {
                design_style
                paragraph {
                  richText
                  text
                }
              }
            }
            ... on PrismicDetailDataBodyHeaderCallout {
              id
              slice_label
              slice_type
              primary {
                header_callout_button_label
                header_callout_button_link {
                  url
                  id
                  type
                  uid
                  tags
                  link_type
                }
                header_callout_text {
                  richText
                  text
                }
                header_callout_title {
                  richText
                  text
                }
              }
            }
            ... on PrismicDetailDataBodyBannerCallout {
              id
              slice_label
              slice_type
              items {
                banner_text
                color
                cta_label
                cta_link {
                  link_type
                  url
                }
                plu_price
                plu_price_description
              }
            }
            ... on PrismicDetailDataBodyRelatedLinks {
              id
              slice_label
              slice_type
              primary {
                related_links_header {
                  richText
                  text
                }
              }
              items {
                description
                link_name
                ex_in_link {
                  link_type
                  ... on PrismicLinkField {
                    url
                  }
                  id
                  tags
                  type
                  uid
                }
              }
            }
            ... on PrismicDetailDataBodyHomeschoolTable {
              id
              slice_label
              slice_type
              items {
                start_date
                end_date
                time_range
                class_name
                cta_label
                cta_link {
                  link_type
                  url
                }
              }
              primary {
                title1 {
                  richText
                  text
                }
              }
            }
            ... on PrismicDetailDataBodyDateTable5Column {
              id
              slice_type
              slice_label
              items {
                column
                column_a
                column_b
                end_date_time
                start_date_time
                form_link {
                  link_type
                  id
                }
              }
            }
            ... on PrismicDetailDataBodyAddOns {
              id
              slice_type
              slice_label
              items {
                add_on_text: description {
                  richText
                  text
                }
                icon_selector
                add_on_title {
                  richText
                  text
                }
              }
              primary {
                title: title1 {
                  richText
                  text
                }
              }
            }
            ... on PrismicDetailDataBodyDetailedCallout {
              id
              slice_label
              slice_type
              items {
                color
                button_label
                body_text
                cta1 {
                  link_type
                  id
                  type
                  tags
                  uid
                  url
                }
                image: image1 {
                  alt
                  url
                }
                title: title1 {
                  richText
                  text
                }
              }
            }
            ... on PrismicDetailDataBodyDetailedCallout2 {
              id
              slice_label
              slice_type
              items {
                title: title1 {
                  richText
                  text
                }
                text: text1 {
                  richText
                  text
                }
                second_cta_label
                second_link {
                  link_type
                  id
                  type
                  tags
                  uid
                  url
                }
                cta_label
                link {
                  id
                  type
                  tags
                  uid
                  url
                }
                color
                image1 {
                  alt
                  url
                }
              }
            }
            ... on PrismicDetailDataBodyMedia {
              id
              slice_type
              slice_label
              primary {
                text {
                  richText
                  text
                }
              }
              items {
                media_link {
                  link_type
                  url
                }
              }
            }
            ... on PrismicDetailDataBodyCognitoForm {
              id
              slice_label
              slice_type
              primary {
                form_id_number
              }
            }
            ... on PrismicDetailDataBodyWishListCards {
              id
              slice_type
              items {
                wish_list_card_title
                wish_list_card_icon
                wish_list_card_descriptio {
                  richText
                }
                wish_list_card_modal_body_text {
                  richText
                }
              }
            }
          }
        }
        id
        uid
        tags
      }
    }
  }
`
